import React from 'react';
import LazyLoad from 'react-lazyload';

const PlacementImage = ({ placementImage }) => {
	return (
		<div className="accent-image">
			<LazyLoad once={ true } offset={ 200 }>
				<img src={ placementImage } alt="" />
			</LazyLoad>
		</div>
	);
};

export default PlacementImage;


// WEBPACK FOOTER //
// ./src/pages/product/PlacementImage.js